import {ILayoutState, initialLayoutState} from '@app/core/store/state/layout.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {ELayoutActions, LayoutActions} from '@app/core/store/actions/layout.actions';

export const layoutReducers = (
	state = initialLayoutState,
	action: LayoutActions | ErrorActions,
): ILayoutState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ELayoutActions.SetSidebarPresentAsOverlay: {
			return {
				...state,
				sidebarPresentAsOverlay: action.presentAsOverlay
			};
		}
		case ELayoutActions.SetSidebarPresentAsOverlayVisible: {
			return {
				...state,
				sidebarPresentAsOverlayVisible: action.presentAsOverlayVisible
			};
		}
		default:
			return state;
	}
};
